import cloneDeep from 'lodash/cloneDeep'
import isBoolean from 'lodash/isBoolean'
import map from 'lodash/map'
import isUndefined from 'lodash/isUndefined'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import clone from 'lodash/clone'

export const deleteKeys = (object, keys, options: any = {}) => {
  //copied the code from https://github.com/miktam/key-del
  const DOT_SEPARATOR = '.'

  const deleteKeysFromObject = (object, keys, options) => {
    let keysToDelete

    // deep copy by default
    let isDeep = true

    // to preserve backwards compatibility, assume that only explicit options means shallow copy
    if (isUndefined(options) === false) {
      if (isBoolean(options.copy)) {
        isDeep = options.copy
      }
    }

    // do not modify original object if copy is true (default)
    let finalObject: any
    if (isDeep) {
      finalObject = isDeep ? cloneDeep(object) : clone(object)
    } else {
      finalObject = object
    }

    if (typeof finalObject === 'undefined') {
      throw new Error('undefined is not a valid object.')
    }
    // if (arguments.length < 2) {
    //   throw new Error('provide at least two parameters: object and list of keys')
    // }

    // collect keys
    if (Array.isArray(keys)) {
      keysToDelete = keys
    } else {
      keysToDelete = [keys]
    }

    keysToDelete.forEach(function (elem) {
      for (const prop in finalObject) {
        // eslint-disable-next-line no-prototype-builtins
        if (finalObject.hasOwnProperty(prop)) {
          if (elem === prop) {
            // simple key to delete
            delete finalObject[prop]
          } else if (elem.indexOf(DOT_SEPARATOR) !== -1) {
            const parts = elem.split(DOT_SEPARATOR)
            let pathWithoutLastEl

            let lastAttribute

            if (parts && parts.length === 2) {
              lastAttribute = parts[1]
              pathWithoutLastEl = parts[0]
              const nestedObjectRef = finalObject[pathWithoutLastEl]
              if (nestedObjectRef) {
                delete nestedObjectRef[lastAttribute]
              }
            } else if (parts && parts.length === 3) {
              // last attribute is the last part of the parts
              lastAttribute = parts[2]
              const deepestRef = finalObject[parts[0]][parts[1]]
              delete deepestRef[lastAttribute]
            } else {
              throw new Error(`Nested level ${parts.length} is not supported yet`)
            }
          } else {
            if (isObject(finalObject[prop])) {
              if (isArray(finalObject[prop])) {
                finalObject[prop] = map(finalObject[prop], function (obj) {
                  return deleteKeysFromObject(obj, keysToDelete, options)
                })
              } else {
                finalObject[prop] = deleteKeysFromObject(finalObject[prop], keysToDelete, options)
              }
            }
          }
        }
      }
    })

    return finalObject
  }

  return deleteKeysFromObject(object, keys, options)
}
